import IMProvidersList from './IMProvidersList';

export default IMProvidersList;
